import { BrowserRouter, Route, Routes } from "react-router-dom";
import { MemberLayout } from "./components/MemberLayout";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { AuthProvider } from "./lib/auth-context";
import { AccountPage } from "./pages/AccountPage";
import { ActivityPage } from "./pages/ActivityPage";
import { CashOutPage } from "./pages/CashOutPage";
import { DemoCompletePage } from "./pages/DemoCompletePage";
import { EarnPage } from "./pages/EarnPage";
import { GoalPage } from "./pages/GoalPage";
import { LandingPage } from "./pages/LandingPage";
import { LoginPage } from "./pages/LoginPage";
import { MissingCreditPage } from "./pages/MissingCreditPage";
import { OpsPage } from "./pages/OpsPage";
import { ForgotPasswordPage, ResetPasswordPage } from "./pages/PasswordResetPages";
import { NotFoundPage, PrivacyPage, SupportPage, TermsPage } from "./pages/StaticPage";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/lp/:slug" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/ops" element={<OpsPage />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/onboarding/goal" element={<GoalPage />} />
            <Route path="/demo/complete/:attemptId" element={<DemoCompletePage />} />
            <Route element={<MemberLayout />}>
              <Route path="/earn" element={<EarnPage />} />
              <Route path="/activity" element={<ActivityPage />} />
              <Route path="/cash-out" element={<CashOutPage />} />
              <Route path="/account" element={<AccountPage />} />
              <Route path="/support/missing-credit" element={<MissingCreditPage />} />
            </Route>
          </Route>
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
